module.exports = "<app-head></app-head>\n<router-outlet></router-outlet>\n<app-footer class=\"footer\"></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// /home1/jenkins/jobs/SUPPORTCS_AJS_PROD/workspace/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main